const Interpolator = require('string-interpolation')

const interpolatorOptions: any = {
    delimiter: ['|', '|']
}

export const getKey = (key: string) => `__${key}`
export const interpolator = new Interpolator()
export const domParser = new DOMParser()
